import _ from 'lodash';
import uuid from 'uuid/v4';
import * as treeUtils from '../components/common/DynamicTree/DynamicTreeUtils';
import * as types from '../actions/actionTypes';
import {
  dictionaryTree,
  dictionaryTarget,
  dictionaryAnswerTarget,
} from './initialState';
import * as CrosstabUtils from '../util/CrosstabUtils';

const initialState = {
  dictionaryTree,
  dictionaryTarget,
  dictionaryAnswerTarget,
  treeLoadNodesList: [],
  functionBox: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_DICTIONARY_TREE_LOAD: {
      const updatedProps = {};
      if ('active' in action.node) {
        updatedProps.active = action.node.active;
      }
      if ('toggled' in action.node) {
        updatedProps.toggled = action.node.toggled;
      }

      const deepTreeCopy = treeUtils.getDeepTreeCopy(state.dictionaryTree.data);
      let data = '';
      if (action.node.node) {
        data = treeUtils.updateTreeNode(
          deepTreeCopy,
          updatedProps,
          action.node.node,
        );
      } else {
        data = treeUtils.updateTreeNode(
          deepTreeCopy,
          updatedProps,
          action.node.recno,
          (node, recno) => node.recno === recno,
        );
      }

      if (data) {
        return {
          ...state,
          dictionaryTree: {
            ...state.dictionaryTree,
            data,
          },
        };
      }

      return state;
    }
    case types.GET_DICTIONARY_TREE_LOAD: {
      let treeLoadNodesList = action.nodeID === 0 ? [] : state.treeLoadNodesList;
      if (!treeLoadNodesList.includes(Number(action.nodeID))) {
        treeLoadNodesList = [
          ...treeLoadNodesList,
          action.nodeID,
        ];
      }

      if (action.nodeID !== 0) {
        const deepTreeCopy = treeUtils.getDeepTreeCopy(
          state.dictionaryTree.data,
        );
        const data = treeUtils.updateTreeNode(
          deepTreeCopy,
          { children: action.payload.data },
          action.nodeID,
        );
        return {
          ...state,
          treeLoadNodesList,
          dictionaryTree: {
            ...state.dictionaryTree,
            data,
          },
        };
      }
      return {
        ...state,
        treeLoadNodesList,
        dictionaryTree: action.payload,
      };
    }

    case types.CLEAR_TREE_LOAD_NODE_LIST: {
      return {
        ...state,
        dictionaryTree: {
          status: 200,
          data: [],
        },
        treeLoadNodesList: [],
      };
    }

    case types.CLEAR_TREE_NODE: {
      return {
        ...state,
        treeLoadNodesList: [],
      };
    }

    case types.SEARCH_DICTIONARY_TREE_LOAD:
      return {
        ...state,
        dictionaryTree: action.payload,
      };
    case types.GET_DICTIONARY_TARGET_LOAD: {
      const targetData = action.payload.data.map(target => ({
        ...target,
        objectType: 'operand',
      }));
      action.payload.data = targetData;
      if (action.isTargetAnswer) {
        return {
          ...state,
          dictionaryAnswerTarget: action.payload,
        };
      }
      return {
        ...state,
        dictionaryTarget: { ...action.payload,
            selectedNode: action.selectedNode,
            useQuestions: action.useQuestions,
            componentGridCategory: action.componentGridCategory,
          },
      };
    }
    case types.GET_DICTIONARY_TARGET_LOAD_FROM_SEARCH: {
      const dictionaryData = _.cloneDeep(action.payload.data);
      dictionaryData.map(element => {
        if (!element.node) {
          element.node = element.recno;
        }
        return element;
      });
      action.payload.data = dictionaryData;
      return {
        ...state,
        dictionaryAnswerTarget: action.payload,
        dictionaryTarget: action.payload,
      };
    }
    case types.RESET_DICTIONARY_TARGET: {
      return {
        ...state,
        dictionaryTarget: { status: 200, data: [] },
        dictionaryAnswerTarget: { status: 200, data: [] },
      };
    }

    case types.FUNCTION_SAMPLE_WEIGHTED: {
      // Required Parameters: payload, targetGrid, expressionList, selectedNames
      // Optional Parameters: sourceGrid, gridData, titlePrefix, originalNames
      const keyType = `${action.targetGrid}Data`;
      let gridData = [];
      const userDefinedText = action.userDefinedText;
      const oldProductNo = action.oldProductNo && action.oldProductNo;
      if (action.gridData || (oldProductNo && oldProductNo !== action.productNo)) {
        gridData = action.gridData ? action.gridData : [];
      } else if (state[keyType]) {
        gridData = state[keyType];
      }
      const titlePrefix = action.titlePrefix ? action.titlePrefix : '';

      const savedKPIs = { ...state.allSelectedKPIsInfo };
      const sampleWeightedKPIs = { ...state.sampleWeightedKPIs };
      action.expressionList.forEach((item, index) => {
        savedKPIs[item] = {
          modeled: action.payload[index] ? action.payload[index].modeled : false,
          productNo: action.productNo,
        };
        sampleWeightedKPIs[item] = {
          productNo: action.productNo,
          data: action.payload[index] ? [action.payload[index]] : [],
        };
      });
      const keywordArr = gridData.map(elems => {
        return elems.keyword.trim();
      });
      const titleArr = gridData.map(elems => {
        return elems.title.trim().toUpperCase();
      });
      const draggedItems = [];
      action.payload.forEach((selectedEntry, index) => {
        let title = '';
        const isLabelUpdated = action.isLabelUpdated ? action.isLabelUpdated[index] : undefined;
        if (action.sourceGrid !== 'FunctionBox' &&
          action.targetGrid !== 'FunctionBoxCountDataGrid') {
          title = `${titlePrefix.toUpperCase()}${action.selectedNames[index].toUpperCase()}`;
        }
        if (action.targetGrid === 'FunctionBoxCountDataGrid') {
          title = titlePrefix ?
            `${titlePrefix.toUpperCase()}${action.selectedNames[index].toUpperCase()}` : '';
        }
        if (action.sourceGrid === 'FunctionBox') {
          title = action.selectedNames[index].toUpperCase();
        }
        let originalTitle = title;
        const rectype = action.recTypes && action.recTypes[index];
        originalTitle = CrosstabUtils.DEFAULT_GRID_CELL_LABEL;
        
        const weighted =
          selectedEntry && selectedEntry.weighted ?
          Number(selectedEntry.weighted) :
          '';
        const updatedWeighted =
          action.targetGrid === 'FunctionBoxCommonDataGrid' ||
          action.targetGrid === 'FunctionBoxCountDataGrid' ?
          CrosstabUtils.smartRoundOff(weighted * 1000) :
          CrosstabUtils.smartRoundOff(weighted);

        if (keywordArr.indexOf(action.expressionList[index].trim()) === -1 ||
          titleArr.indexOf(title.trim()) === -1 || action.weightChange) {
          draggedItems.push({
            id: uuid(),
            sample: selectedEntry && selectedEntry.intab ? selectedEntry.intab : '',
            keyword: action.expressionList[index],
            weighted: updatedWeighted === 0 ? '' : updatedWeighted,
            title,
            originalTitle,
            rectype,
            userDefinedText,
            dataSmartSearch: action.objSmartSearchArray && action.objSmartSearchArray[index] ?
              action.objSmartSearchArray[index] : [],
            isLabelUpdated,
          });
        }
      });
      let finalData = [];
      finalData = [...gridData, ...draggedItems];
      const deepTreeCopy = treeUtils.getDeepTreeCopy(state.functionBox);
      const updateFunctionBox = {
        [keyType]: finalData,
      };
      return {
        ...state,
        functionBox: {
          ...deepTreeCopy,
          ...updateFunctionBox,
        },
      };
    }

    case types.CLEAR_DICTIONARY_SAMPLE_WEIGHTED: {
      const keyType = `${action.targetGrid}Data`;
      const deepTreeCopy = treeUtils.getDeepTreeCopy(state.functionBox);
      const updateFunctionBox = {
        [keyType]: [],
      };
      return {
        ...state,
        functionBox: {
          ...deepTreeCopy,
          ...updateFunctionBox,
        },
      };
    }
    default:
      return state;
  }
}
